import { webApi } from '@mi-front/api-clients';

/**
 * Deletes a video editor edit and triggers an optional success callback.
 */
export function useEditCardDelete(editId: string, onSuccess?: () => Promise<void> | void) {
  const deleteMutation = webApi.useDeleteVideoEditorEditsEdit({
    mutation: {
      onSuccess: async () => {
        await onSuccess?.();
      },
    },
  });

  const handleDelete = async () => {
    await deleteMutation.mutateAsync({ id: editId });
  };

  return { handleDelete };
}
